export default [
  {
    path: '/agendas/inbox',
    name: 'Agendas_Inbox',
    component: () => import('@/views/agenda/inbox.vue'),
    meta: {
      pageTitle: 'صورت جلسات من',
      authRequired: true,
      permission: 'agendas.inbox',
    },
  },
  {
    path: '/agendas',
    name: 'Agendas_Sent',
    component: () => import('@/views/agenda/sent.vue'),
    meta: {
      pageTitle: 'صورت جلسات ثبت شده',
      authRequired: true,
      permission: 'agendas.index',
    },
  },
  {
    path: '/agendas/create',
    name: 'Agendas_Create',
    component: () => import('@/views/agenda/create.vue'),
    meta: {
      pageTitle: 'ایجاد صورتجلسه',
      authRequired: true,
      permission: 'agendas.store',
    },
  },
  {
    path: '/agendas/:id',
    name: 'Agendas_Detail',
    component: () => import('@/views/agenda/show.vue'),
    meta: {
      authRequired: true,
      permission: 'agendas.show',
    },
  },
  {
    path: '/agendas/:id/edit',
    name: 'Agendas_Update',
    component: () => import('@/views/agenda/edit.vue'),
    meta: {
      authRequired: true,
      permission: 'agendas.update',
    },
  },
]
